import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icon/chat-blue-grey.svg'
import _imports_1 from '@/assets/img/icon/sandtime-outline-orange.svg'
import _imports_2 from '@/assets/img/icon/van-red.svg'
import _imports_3 from '@/assets/img/icon/scooter-outline-green.svg'
import _imports_4 from '@/assets/img/icon/package-red.svg'


const _hoisted_1 = { class: "card-ready-pick-up" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "w-full md:flex md:justify-between md:items-center" }
const _hoisted_4 = { class: "md:flex md:items-center md:gap-4" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "flex gap-2 items-center" }
const _hoisted_7 = { class: "font-bold text-sm text-black" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "h-8",
  style: {"border-left":"1px solid #B0BEC5"}
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-white text-xs font-bold" }, "Jemput Semua", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-arrow-right text-white text-xs font-bold" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "color-red text-xs font-bold" }, "Menunggu Konfirmasi", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"width":"7px"}
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  style: {"width":"14px"}
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "color-red text-xs font-bold" }, "Sedang Dijemput", -1)
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "color-blue-grey font-bold pt-3 text-xs md:text-right md:pt-0" }
const _hoisted_18 = { class: "mt-4 ml-10 w-2/3 md:w-1/2 lg:w-1/3" }
const _hoisted_19 = { class: "color-blue-grey text-xs" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "card-ready-delivery" }
const _hoisted_22 = { class: "mr-3 flex items-start" }
const _hoisted_23 = {
  key: 0,
  class: "rounded-icon assigned"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_25 = {
  key: 1,
  class: "rounded-icon waiting"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_27 = {
  key: 2,
  class: "rounded-icon"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_29 = { class: "card-content grid grid-cols-8 gap-4 items-start border-bottom-blue-grey-lighten-4 pb-4 w-full" }
const _hoisted_30 = { class: "max-w-sm col-span-8 lg:col-span-2" }
const _hoisted_31 = { class: "text-black font-semibold break-words" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "color-blue-grey text-sm flex" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = {
  class: "",
  style: {"list-style-type":"none"}
}
const _hoisted_36 = { class: "ml-8" }
const _hoisted_37 = { class: "max-w-sm col-span-4 lg:col-span-2 hidden lg:block" }
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-xs" }, "Dari - Ke", -1)
const _hoisted_39 = { class: "text-black font-semibold text-sm break-words" }
const _hoisted_40 = { class: "max-w-sm col-span-4 lg:col-span-2" }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-xs" }, "Jam Jemput", -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createVNode("p", { class: "text-green-500 font-semibold text-sm break-words" }, /*#__PURE__*/_toDisplayString('-'), -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "text-green-500 font-semibold text-sm break-words" }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { class: "text-red-500 font-semibold text-sm break-words" }
const _hoisted_48 = { class: "text-red-500 font-semibold text-sm break-words" }
const _hoisted_49 = { key: 3 }
const _hoisted_50 = { class: "text-black font-semibold text-sm break-words" }
const _hoisted_51 = { class: "text-black font-semibold text-sm break-words" }
const _hoisted_52 = { class: "max-w-sm col-span-3 lg:col-span-1" }
const _hoisted_53 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-xs" }, "Kurir Penjemput", -1)
const _hoisted_54 = { class: "text-black font-semibold text-sm break-words" }
const _hoisted_55 = { class: "flex justify-center items-center" }
const _hoisted_56 = {
  key: 0,
  class: ""
}
const _hoisted_57 = /*#__PURE__*/_createVNode("p", { class: "text-white text-xs font-bold" }, "ACC Pembatalan Paket", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("i", { class: "pi pi-arrow-right text-white text-xs font-bold" }, null, -1)
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/_createVNode("p", { class: "text-xs text-white" }, "Konf. Pengembalian Paket", -1)
const _hoisted_61 = {
  key: 2,
  class: "background-grey-lighten-5 rounded-full cursor-pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "card-no-shadow card-p-0 mb-8" }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_Avatar, {
                    label: _ctx.data.Pengirim.charAt(0),
                    shape: "circle"
                  }, null, 8, ["label"]),
                  _createVNode("p", _hoisted_7, _toDisplayString(_ctx.data.Pengirim), 1)
                ]),
                _hoisted_8,
                _createVNode("i", {
                  class: "pi pi-phone color-blue-grey-darken-1 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toTelp(_ctx.$convertPhoneNumber(_ctx.data.HpPengirim))))
                }),
                _createVNode("img", {
                  src: _imports_0,
                  class: "cursor-pointer",
                  style: {"width":"1.3rem"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$goWhatsApps(_ctx.data.HpPengirim)))
                })
              ]),
              (!_ctx.data.IsPickup)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "btn-red p-button-sm flex gap-2 rounded-md w-full mt-2 md:w-auto md:mt-0",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pickupAll(_ctx.data.data)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  }))
                : (_ctx.data.Status === 18)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode(_component_Button, { class: "btn-red p-button-sm flex gap-2 rounded-md p-button-outlined background-red-lighten-5 cursor-default mt-2 mr-3 w-full md:w-auto md:mt-0" }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      class: "btn-red p-button-sm flex gap-2 rounded-md p-button-outlined background-red-lighten-5 cursor-default mt-2 w-full md:w-auto md:mt-0"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _hoisted_15
                      ]),
                      _: 1
                    }))
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("p", _hoisted_17, _toDisplayString(`Pengiriman Antar Kota -
                ${_ctx.data.KotaAsal}`), 1)
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.data.AlamatPengirim), 1)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_20, [
          _createVNode("section", _hoisted_21, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.data, (value, key) => {
              return (_openBlock(), _createBlock("div", {
                class: ["flex w-full pt-5 px-5 container-ready-delivery", value.KurirMsUserId ? value.StatusPengirimanId === 18 ? 'waiting' : 'assigned' : ''],
                key: key
              }, [
                _createVNode("div", _hoisted_22, [
                  (value.KurirMsUserId && value.StatusPengirimanId !== 18)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _hoisted_24
                      ]))
                    : (value.StatusPengirimanId === 18)
                      ? (_openBlock(), _createBlock("div", _hoisted_25, [
                          _hoisted_26
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_27, [
                          _hoisted_28
                        ]))
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode("p", _hoisted_31, _toDisplayString(value.TransPengirimanDetails.length > 0 ?
                    value.TransPengirimanDetails[0].KategoriBarangNama : '-'), 1),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _createVNode("ul", _hoisted_34, [
                          _createVNode("li", _hoisted_35, _toDisplayString(value.Resi), 1),
                          _createVNode("li", _hoisted_36, _toDisplayString(value.TotalBerat) + " Kg", 1)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode("p", _hoisted_39, _toDisplayString(`${value.KotaAsalNama} -
                                      ${value.KotaTujuanNama}`), 1)
                  ]),
                  _createVNode("div", _hoisted_40, [
                    _hoisted_41,
                    (!value.WaktuMulaiPenjemputan)
                      ? (_openBlock(), _createBlock("div", _hoisted_42, [
                          _hoisted_43
                        ]))
                      : (_ctx.moment().isSame(_ctx.moment(value.WaktuMulaiPenjemputan), 'day'))
                        ? (_openBlock(), _createBlock("div", _hoisted_44, [
                            _createVNode("p", _hoisted_45, _toDisplayString(`Hari ini,
                      ${_ctx.moment(value.WaktuMulaiPenjemputan).format('HH:mm')} -
                                          ${_ctx.moment(value.WaktuAkhirPenjemputan).format('HH:mm')}`), 1)
                          ]))
                        : (_ctx.moment().isAfter(_ctx.moment(value.WaktuMulaiPenjemputan), 'day'))
                          ? (_openBlock(), _createBlock("div", _hoisted_46, [
                              _createVNode("p", _hoisted_47, _toDisplayString(`${_ctx.moment(value.WaktuMulaiPenjemputan).format('dddd')},
                                            ${_ctx.moment(value.WaktuMulaiPenjemputan).format('DD MMMM YYYY')}`), 1),
                              _createVNode("p", _hoisted_48, _toDisplayString(`${_ctx.moment(value.WaktuMulaiPenjemputan).format('HH:mm')} -
                                            ${_ctx.moment(value.WaktuAkhirPenjemputan).format('HH:mm')}`), 1)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_49, [
                              _createVNode("p", _hoisted_50, _toDisplayString(`${_ctx.moment(value.WaktuMulaiPenjemputan).format('dddd')},
                                            ${_ctx.moment(value.WaktuMulaiPenjemputan).format('DD MMMM YYYY')}`), 1),
                              _createVNode("p", _hoisted_51, _toDisplayString(`${_ctx.moment(value.WaktuMulaiPenjemputan).format('HH:mm')} -
                                            ${_ctx.moment(value.WaktuAkhirPenjemputan).format('HH:mm')}`), 1)
                            ]))
                  ]),
                  _createVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode("p", _hoisted_54, _toDisplayString(value.KurirMsUserId ?
                    value.KurirMsUserFullname : '-Belum Ada Kurir-'), 1)
                  ]),
                  _createVNode("div", _hoisted_55, [
                    (value.StatusPengirimanKode === 'MKB')
                      ? (_openBlock(), _createBlock("div", _hoisted_56, [
                          _createVNode(_component_Button, {
                            class: "btn-red p-button-sm flex gap-2 rounded-md w-full mt-2 md:w-auto md:mt-0",
                            onClick: ($event: any) => (_ctx.showModalAcceptCancelPackage(value.Id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_57,
                              _hoisted_58
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : (value.StatusPengirimanKode === 'MKK')
                        ? (_openBlock(), _createBlock("div", _hoisted_59, [
                            _createVNode(_component_Button, {
                              class: "btn-primary p-button-sm",
                              onClick: ($event: any) => (_ctx.onConfirmPackageReturn(value))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_60
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_61, [
                            _createVNode("i", {
                              class: "pi pi-ellipsis-h text-base text-black px-2 py-1",
                              "aria:haspopup": "true",
                              "aria-controls": "overlay_panel",
                              onClick: ($event: any) => (_ctx.showDropDown($event, value))
                            }, null, 8, ["onClick"])
                          ]))
                  ])
                ])
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          assignCourier: _ctx.$route.meta?.permission?.update,
          onAssignCourier: _ctx.assignCourier
        }, null, 8, ["assignCourier", "onAssignCourier"])
      ]),
      _: 1
    }, 512)
  ]))
}